//React
import React from "react";
import {
  Link,
} from "react-router-dom";
//Redux
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
//Action
import * as favoriteAction from '../action/favoriteAction';
import * as helpAction from '../action/helpAction';
//Material-ui
import Button from '@material-ui/core/Button';
import Box from '@material-ui/core/Box';
import IconButton from '@material-ui/core/IconButton';
//Add
import Masonry from 'react-masonry-component';
//Func
import atom2datetime from '../func/atom2datetime';
//Menu
import MenuSearch from './MenuSearch';
import MenuFavorite from './MenuFavorite';
//Part
import PartUserName from './PartUserName';
import PartUserMainImg from './PartUserMainImg';
import PartPagingNextPrev from './PartPagingNextPrev';
import PartTimeIcon from './PartTimeIcon';
//Dialog
import DialogConfirm from './DialogConfirm';
//Icon
import MailIcon from '@material-ui/icons/Mail';
import RefreshIcon from '@material-ui/icons/Refresh';
import ClearIcon from '@material-ui/icons/Clear';


class Comp extends React.Component {

  constructor(props) {
    super(props);

  	this.state = {
      favoriteDelPic: null,
  	}
  }

  componentDidMount() {
    document.title = 'お気に入り(相手から) - パートナーズ';
    if (this.props.history.action === 'PUSH' || !this.props.favorite.partner.datetime) {
      this.props.favoritePartnerListGet(1);
      window.scrollTo(0, 0);
    }
  }

  _favoriteDelSubmit() {
    this.props.favoritePartnerDel(this.state.favoriteDelPic, () => {
      this.setState({favoriteDelPic: null});
    });
  }


  _paging(page) {
    this.props.favoritePartnerListGet(page);
    window.scrollTo(0, 0);
  }

  _renderList = (value, index) => {
    return (
      <div key={index} className='box_outer'>
        <Box
          className='box_innner round12'
          boxShadow={2}
          style={{background:(value.favorite_notice_unread === 1) ? '#FFE7C2': '#FFF' }}
        >
          {
            (value.favorite_both === 1) && (
              <div
                className='ribbon_orange'
                style={{position:'absolute', top:'0px', left:'0px',cursor:'pointer'}}
                onClick={ () => this.props.helpOpen('id',45) }
              >
                両思い
              </div>
            )
          }
          <div style={{padding:'2%'}}>
            <div style={{textAlign:'center'}}>
              <Link to={{ pathname: '/partner/' + value.userdata_id_code}}>
                <PartUserName
                  data={{
                    name: value.userdata_name,
                    sex: value.userdata_sex,
                    size: '1.4em',
                  }}
                />
              </Link>
              <div>
                {value.userdata_age}才 {value.userdata_prof_region} {value.userdata_prof_region_detail}
              </div>
            </div>
            <div className='box_left'>
              <div style={{margin:'1%'}}>
                <Link to={{ pathname: '/partner/' + value.userdata_id_code}}>
                  <div align='center'>
                    <PartUserMainImg
                      mainImg={value.userdata_mainImg}
                      maxWidth={'160px'}
                      width={'100%'}
                      height={'auto'}
                      radius={'50%'}
                      lazyLoad={false}
                    />
                  </div>
                </Link>
              </div>
            </div>
            <div className='box_right'>
              {
                (value.userdata_prof_partner_comment.length > 0) &&
                <div
                  className='comment round12'
                  style={{fontSize:'0.9em', color:'#666', margin:'1%'}}
                >
                  {value.userdata_prof_partner_comment}
                </div>
              }

              { (value.userdata_proof_person === 1) && (<span className='proof_icon'>本人証明</span>) }
              { (value.userdata_proof_photo === 1) && (<span className='proof_icon'>写真証明</span>) }
              { (value.userdata_proof_income === 1) && (<span className='proof_icon'>収入証明</span>) }
              { (value.userdata_proof_single === 1) && (<span className='proof_icon'>独身証明</span>) }
              { (value.userdata_proof_credit === 1) && (<span className='proof_icon'>ｸﾚｼﾞｯﾄ証明</span>) }
              { (value.post_count > 0) && (<span className='post_icon'>投稿 {value.post_count}件</span>) }
              { (value.qa_count > 0 || value.qa_answer_count > 0) && (
                <span className='qa_icon'>Q&A
                  { (value.qa_count > 0) && (value.qa_count + '問')}
                  { (value.qa_answer_count > 0) && (value.qa_answer_count + '答')}
                </span>
              ) }
              { (value.character_type16) && (<span className='personality_icon'>性格</span>) }
            </div>
          </div>

          <div style={{clear:'both'}}></div>

          <div style={{textAlign:'center'}}>
            <PartTimeIcon
              text={atom2datetime(value.favorite_datetime_atom, 'D') + ' お気に入り登録'}
            />
          </div>

          <div
            className='favorite_box_menu'
            style={{
              marginTop: '10px',
              borderTop: '1px solid #CCC'
            }}
          >
            <div
              className='item'
              style={{borderRight: '1px solid #CCC'}}
              onClick={ () => this.props.history.push({pathname:"/mailbox/talk/"+value.userdata_id_code, referrer:'/favorite/partner/'}) }
            >
              <MailIcon className='icon'/>
              <div className='text'>メール</div>
            </div>

            <div
              className='item'
              onClick={ () => this.setState({favoriteDelPic: value.userdata_id_code} ) }
            >
              <ClearIcon className='icon'/>
              <div className='text'>削除</div>
            </div>
          </div>
        </Box>
      </div>
    );
  };


  render() {
    return (
      <div>
        <MenuSearch />

        <MenuFavorite />

        <div align='center'>
          あなたをお気に入り登録(通知ON)した会員
        </div>

        <div
          style={{
            display:'flex',
            flexDirection:'row',
            alignItems:'center',
            justifyContent: 'space-between',
            margin: '10px',
          }}
        >
          <div>

          </div>

          <div>
            ページ {this.props.favorite.partner.page}

            <IconButton
              onClick={ () => this.props.favoritePartnerListGet(1) }
            >
              <RefreshIcon />
            </IconButton>
          </div>
        </div>
        {
          (this.props.favorite.partner.datetime) && (
            (this.props.favorite.partner.count > 0) ? (
              (this.props.my.proof.credit === 0 && this.props.my.proof.person === 0) ? (
                <div  align='center'>
                  <h2 align='center' style={{padding:'10px'}}>
                    あなたをお気に入りに<br/>
                    登録した方が{ this.props.favorite.partner.count }人います
                  </h2>
                  <h3 align='center'>
                    <span className='i-b'>お気に入り通知は本人証明を</span>
                    <span className='i-b'>申請いただくと表示されます</span>
                  </h3>
                  <div align='center' style={{padding:'10px'}}>
                    <Button
                      variant="contained"
                      color='secondary'
                      onClick={ () => this.props.history.push('/my/proof/person') }
                      style={{fontSize:'1.2em'}}
                    >
                      本人証明を申請する
                    </Button>
                  </div>
                </div>
              ): (
                <div id="user_list_block">

                  <div>
                    <Masonry options={{
                      itemSelector: '.box_outer',
                      transitionDuration: 0,
                    }}>
                      {
                        this.props.favorite.partner.list.map(
                          (value, index) => this._renderList(value, index)
                        )
                      }
                    </Masonry>
                    <div style={{margin:'15px'}}>
                      <PartPagingNextPrev
                        page={this.props.favorite.partner.page}
                        isNext={this.props.favorite.partner.isListNext}
                        onClick={ (e) => this._paging(e) }
                      />
                    </div>
                  </div>

                </div>
              )
            ): (

              <h2 align='center' style={{padding:'30px 0px'}}>
                <div>お相手からのお気に入りは</div>
                <div>見つかりませんでした</div>
              </h2>

            )
          )
        }

        <div align='center' style={{margin:'15px'}}>
          <Button
            color="primary"
            variant={ "outlined" }
            onClick={ () => this.props.helpOpen('id',365) }
          >
            「お気に入り」(相手から)とは？
          </Button>
        </div>

        <DialogConfirm
          open={ (this.state.favoriteDelPic) ? true : false }
          title={'お気に入り通知を削除'}
          content={(<div>通知を１件削除にしてもいいですか？<br />(お相手は削除したことは判りません)</div>)}
          apply={ () => this._favoriteDelSubmit(this.state.favoriteDelPic) }
          close={ () => this.setState({favoriteDelPic: null}) }
        />
      </div>
    )
  }
}

const mapStateToProps = (state) => {
	return {
		favorite: state.favorite,
    my: state.my,
	}
};

const mapDispatchToProps = (dispatch) => {
	return bindActionCreators({
    ...favoriteAction,
    ...helpAction,
	}, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(Comp);
